import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { OutlinedInput, InputLabel, ListItemText, Checkbox } from '@mui/material'
import { MuiCheckbox, MuiTextField } from '../'
import { IconSearchbar, IconSelectArrow } from '../../assets/images/icons'

import {
  FormLabel,
  FormSelectWrap,
  SelectWrapper,
  FormError,
  StyledMenuItem,
  StyledSelect,
  SelectThemeV2Wrapper,
  FieldWrapper,
} from './style'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  autoFocus: false,
  disableRestoreFocus: true,
  MenuListProps: {
    disablePadding: true, // Sometimes helps with alignment
  },
  PaperProps: {
    onTransitionEnter: (node) => {
      node.scrollTop = 0;
    },
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const MuiMultiSelect = (props) => {
  const {
    style,
    data,
    onChange,
    size,
    placeholder,
    compact = false,
    value,
    onSelectAll = null,
    search = false,
    allCheckedByDefault = true
  } = props

  const [selectedValue, setSelectedValue] = useState([])

  const [searchInput , setSearchInput] = useState('');

  const checkSpecialChar = (s) => {
    return s
      .toString()
      .replace(/\\/g, '\\\\')
      .replace(/[^a-z0-9 ]+/gi, '')
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    const finalValue = typeof value === 'string' ? value.split(',') : value
    setSelectedValue(finalValue)
    onChange(finalValue)
  }

  const selectAllFunc = () => {
    const isChecked = data.length === selectedValue.length
    onSelectAll(!isChecked)
  }

  useEffect(() => {
    setSelectedValue(value)
  }, [value, data])

  useEffect(() => {
    setTimeout(() => {
      if( !allCheckedByDefault ){
        setSelectedValue([])
      }
    }, 500)
  }, [])

  return (
  <SelectThemeV2Wrapper className='SelectThemeV2Wrapper' style={style}>
      {props?.title && <FormLabel className='formLabel'>{props.title}</FormLabel>}
      <FormSelectWrap
        className={`multiSelectWrap ${selectedValue?.length === 0 && placeholder ? 'showPlaceHolder' : ''}`}
      >
        {props?.data && (
          <>
            {selectedValue?.length === 0 && placeholder && (
              <InputLabel id={`demo-multiple-checkbox-label`} className='selectPlaceholder'>
                {placeholder}
              </InputLabel>
            )}
            <SelectWrapper>
              <StyledSelect
                MenuProps={MenuProps}
                labelId={`demo-multiple-checkbox-label`}
                id={`demo-multiple-checkbox`}
                multiple
                value={selectedValue || []}
                compact={compact ? 'true' : ''}
                onChange={handleChange}
                size={size}
                IconComponent={(p) => <IconSelectArrow className='dropdownArrow' />}
                input={<OutlinedInput label={placeholder} />}
                renderValue={(selected) => selected.join(', ')}
              >
                {search && 
                <FieldWrapper onClick={(e) => e.stopPropagation()}>
                <MuiTextField
                  placeholder='Search'
                  name='search'
                  onChange={(e) => setSearchInput(checkSpecialChar(e.target.value))}
                  type='text'
                  value={searchInput}
                  variant='outlined'
                  className='searchBox'
                  styletype='themeV2'
                  InputProps={{
                    startAdornment: <IconSearchbar />,
                  }}
                  /></FieldWrapper>}
                {onSelectAll && <StyledMenuItem value={'All'} single='true' className='small'>
                  <ListItemText primary={'All'} />
                  <MuiCheckbox
                    styling='themeV2'
                    size='small'
                    checked={data?.length === selectedValue?.length}
                    onChange={selectAllFunc}
                  />
                </StyledMenuItem>}
                {search && data 
                  .map((name) => (
                    <StyledMenuItem key={name} value={name} single='true' className='small'>
                      <ListItemText primary={name} />
                      <MuiCheckbox styling='themeV2' size='small' checked={selectedValue?.includes(name)} />
                    </StyledMenuItem>
                  ))}
                {!search && data.map((name) => (
                  <StyledMenuItem key={name} value={name} single='true' className='small'>
                    <ListItemText primary={name} />
                    <MuiCheckbox
                      styling='themeV2'
                      size='small'
                      checked={selectedValue?.includes(name)}
                    />
                  </StyledMenuItem>
                ))}
              </StyledSelect>
            </SelectWrapper>
          </>
        )}
      </FormSelectWrap>
      {props?.error && <FormError className='selectError'>{props?.error}</FormError>}
    </SelectThemeV2Wrapper>
  )
}

MuiMultiSelect.propTypes = {
  style: PropTypes.object,
  title: PropTypes.string,
  data: PropTypes.array,
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  selectlabel: PropTypes.string,
  selectvalue: PropTypes.string,
  size: PropTypes.string,
  placeholder: PropTypes.string,
  compact: PropTypes.bool,
  menuprops: PropTypes.object,
  error: PropTypes.string,
}

export default MuiMultiSelect
